export default __webpack_public_path__ + "static/AkankshaS-ea0819ab6f99e21e177e0b206ea5a216.png";